"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ShopStatus=void 0;var t;(function(e){e.Close="close",e.Open="open"})(t||(exports.ShopStatus=t={}));
//# sourceMappingURL=ShopStatus.js.map
